enum WebRecordingSettingsTypes {
  Set = 'webRecordingSettings.set',
  FetchRequest = 'webRecordingSettings.fetchRequest',
  FetchSuccess = 'webRecordingSettings.fetchSuccess',
  FetchFailure = 'webRecordingSettings.fetchFailure',
  UpdateRequest = 'webRecordingSettings.updateRequest',
  UpdateSuccess = 'webRecordingSettings.updateSuccess',
  UpdateFailure = 'webRecordingSettings.updateFailure',
  UpdateBlockedUserAgentsRequest = 'webRecordingSettings.updateBlockedUserAgentsRequest',
  UpdateBlockedUserAgentsSuccess = 'webRecordingSettings.updateBlockedUserAgentsSuccess',
  UpdateBlockedUserAgentsFailure = 'webRecordingSettings.updateBlockedUserAgentsFailure',
  UpdateBlockedIpsRequest = 'webRecordingSettings.updateBlockedIpsRequest',
  UpdateBlockedIpsSuccess = 'webRecordingSettings.updateBlockedIpsSuccess',
  UpdateBlockedIpsFailure = 'webRecordingSettings.updateBlockedIpsFailure',
}

export { WebRecordingSettingsTypes };
